import { jwtDecode } from "jwt-decode";
import { useCallback, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Dispatch } from "redux";
import { EXTERNAL_LOGIN_URL } from "../consts";
import { LexTokenPayload } from "../models";
import { doLogout, loginWithToken } from "../store/reducer/_sessionReducer";
import { RootState } from "../store/reducer/_store";
import { removeLoggedStatus, removeLoggedUser, removeToken } from "../utils";

export function useValidateToken() {
  const dispatch = useDispatch();

  const token = useSelector((state: RootState) => state.sessionContext.token);
  const loggedUser = useSelector(
    (state: RootState) => state.sessionContext.loggedUser
  );

  const hasValidatedRef = useRef(false);

  const handleValid = useCallback(
    (token: string) => {
      try {
        const decoded = jwtDecode<LexTokenPayload>(token);
        const nowInSeconds = Date.now() / 1000;
        if (!decoded.exp || decoded.exp < nowInSeconds) {
          handleInvalidToken(dispatch);
          return;
        }

        if (!loggedUser) {
          dispatch(
            loginWithToken({
              user: decoded.cliente,
              token,
            })
          );
        }
      } catch {
        handleInvalidToken(dispatch);
      }
    },
    [dispatch, loggedUser]
  );

  useEffect(() => {
    if (hasValidatedRef.current) return;
    hasValidatedRef.current = true;

    if (!token) {
      redirectToExternalLogin();
      return;
    } else handleValid(token);
  }, [token, handleValid]);
}

function handleInvalidToken(dispatch: Dispatch) {
  removeLoggedStatus();
  removeLoggedUser();
  removeToken();
  dispatch(doLogout());
  window.location.href = EXTERNAL_LOGIN_URL;
}

function redirectToExternalLogin() {
  window.location.href = EXTERNAL_LOGIN_URL;
}
